package com.patronat.top.features.venues.domain.usecase.command

data class ReviewVenueDraftCommand(
    val venueId: String,
    val approved: Boolean
)
